import React, {useEffect, useState, useRef} from 'react'
import {Row, Col, Tabs, Card, Tooltip, Button} from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import { connect } from 'react-redux'

import OwnAccount from './OwnAccount'
import OtherAccount from './OtherAccount'

import './index.scss'
import {TabsInfoIco} from "../../../../../modules/CustomIcons";
import {useHistory, useLocation} from "react-router-dom";
import CustomTooltip from "components/Tooltip";
import {getPathnameByIndex} from "../../../../services/helper";
import {checkPermission} from "../../../../services/permission";
import {getCurrentCompany} from "../../../../services/user";
import { useTranslation } from 'react-i18next'
import noSelected from "assets/images/noSelectedTransfer.svg";
import messageList from "assets/locales/translate.json";
import {getMessageLists} from "store/actions/home";
import { useConveyer } from "@egjs/react-conveyer";





const TransferBanks: React.FC<any> = ({companyData,messageList}) => {
    const {t} = useTranslation()
    const ref = useRef<HTMLDivElement>(null);
    useConveyer(ref, {
        horizontal: true,
    });

    const language = localStorage.getItem("i18nextLng")
    const [textArray_Own,setTextArray_Own] = useState([])
    const [textArray_Other,setTextArray_Other] = useState([])
    const fetchessageData = async () => {
        let lang_text_own = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_OWN')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_OWN')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_OWN')?.textENG :"") : "";

        const array_own = lang_text_own !== null  && lang_text_own !== undefined ? lang_text_own.split("|") : [];

        let lang_text_other = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_OTHER')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_OTHER')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_OTHER')?.textENG :"") : "";

        const array_other = lang_text_other !== null && lang_text_other !== undefined ? lang_text_other.split("|") : [] ;

        setTextArray_Own(array_own);
        setTextArray_Other(array_other)
    };
    useEffect(() => {
        fetchessageData()
    }, [messageList,language])
    const TooltipMessageOwn = `
    ${
        textArray_Own.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `
    const TooltipMessageOther = `
    ${
        textArray_Other.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const tabInnerData: Array<any> = [
        {
            index: 1,
            title: t("newTransfer.ownAccount"),
            description : TooltipMessageOwn  ,
            content: <OwnAccount/>,
            path : '/new_transfer/inside_bank/own_account',
            permissionKey : 'OWN_ACCOUNT',
        },
        {
            index: 2,
            title: t("newTransfer.toOtherAccount"),
            description: TooltipMessageOther ,
            content: <OtherAccount/>,
            path : '/new_transfer/inside_bank/other_account',
            permissionKey : 'INTERNAL',
        },
    ]
  const { TabPane } = Tabs;

    const history = useHistory();
    const location = useLocation();
    const find_tab = tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));
    const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);






    useEffect(() => {
        const find_tab = tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));

        setTabActiveKey(find_tab?.index);
    }, [location, companyData,messageList])



    const tabOnChange = (activeKey) => {
        setTabActiveKey(old_key => activeKey);

        const find_row=tabInnerData.find(row => row.index==activeKey);

        if (find_row) {
            history.push(find_row.path);
        }
    };

  return (
    <Row className='transfer_child_tabs' ref={ref}>
      <Col span={24} style={{minWidth: "800px"}}>
          <Tabs
              activeKey={`${tabActiveKey}`}
              onChange={tabOnChange}
              id="transferTab"
              destroyInactiveTabPane={true}
          >

            {tabInnerData &&
              tabInnerData.map((item, index) => {
                let span_class=(tabInnerData.length - 1 == index) ? 'is_last_span' : '';
                return checkPermission(item.permissionKey) && (
                  <TabPane className={span_class} tab={
                      <span className={`transfer_child_tabs_${item.index} ${span_class}`} >
                      {item.title}
                          <CustomTooltip
                              title={item.description}
                          >
                              <Button type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
                          </CustomTooltip>

                      </span>} key={item.index}>
                    {item.content}
                  </TabPane>
                )
              })}
          </Tabs>
      </Col>
        { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
            <img src={noSelected}/>
              </span> }
    </Row>
  )
}
const mapDispatchToProps = { getMessageLists }
const mapStateToProps = (state: any) => ({
    companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany(),
    messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(TransferBanks)
